import { Priority } from '@/models/appointment/Appointment.ts';

export const color_mapping = {
    [Priority.LOW]: 'black',
    [Priority.NORMAL]: 'green-400',
    [Priority.IMPORTANT]: 'yellow-400',
    [Priority.VERYIMPORTANT]: 'orange-400',
    [Priority.CRITICAL]: 'red-400',
};
